/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdIndexesAnchorProps } from '../indexes/type';
import { PropType } from 'vue';

export default {
  /** 索引字符 */
  index: {
    type: [String, Number] as PropType<TdIndexesAnchorProps['index']>,
  },
};
